import { FC, useState } from 'react';
import { Form, Typography } from 'antd';
import { Trans } from 'react-i18next';
import { differenceInSeconds } from 'date-fns';

import { FormItem, SubmitButton, TextField } from 'componets/form';
import { Timer } from 'componets/common';

import { Rules } from 'utils/constants';
import Utils from 'utils/utils';

import { FieldData } from 'models';

import { recoveryPassword } from 'features/forgotPassword/actions';

import { useAppDispatch, useTranslate } from 'hooks';

import s from './index.module.scss';

export const ForgotPasswordRecovery: FC = () => {
	const [limit, setLimit] = useState(false);
	const [seconds, setSeconds] = useState(0);

	const t = useTranslate([
		'passwordResetText',
		'passwordResetInfoText',
		'emailText',
		'sendText',
		'errorLimitText',
	]);

	const [fields, setFields] = useState<FieldData[]>([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const dispatch = useAppDispatch();

	const onFinish = (data: { email: string }) => {
		setIsSubmitting(true);
		dispatch(recoveryPassword(data))
			.unwrap()
			.catch(({ errors }) => {
				if (errors.limit) {
					const lockedUntil = differenceInSeconds(errors.limit.lockedUntil * 1000, new Date());

					setSeconds(lockedUntil);
					setLimit(true);
					setFields([{ name: ['email'], errors: [t.errorLimitText] }]);

					return;
				}
				Utils.injectFormErrors(fields, errors, setFields);
			})
			.finally(() => {
				setIsSubmitting(false);
			});
	};

	return (
		<>
			<Typography.Title level={4}>{t.passwordResetText}</Typography.Title>
			<Typography.Text>{t.passwordResetInfoText}</Typography.Text>
			<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields} className={s.form}>
				<FormItem
					rules={[Rules.REQUIRED, Rules.EMAIL]}
					name="email"
					validateTrigger="onSubmit"
					className={s.email}
				>
					<TextField label={t.emailText} />
				</FormItem>

				<div className={s.limit}>
					{limit && (
						<Timer
							seconds={seconds}
							onEnd={() => {
								setLimit(false);
								setSeconds(0);
							}}
							render={(time: number) => (
								<Trans i18nKey="timerText" values={{ value: Utils.formatTime(time) }} />
							)}
						/>
					)}
				</div>

				<SubmitButton text={t.sendText} loading={isSubmitting} disabled={limit} />
			</Form>
		</>
	);
};
